import { VehicleCategory } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { svcDropdownsFeatureSelector } from '../svc-dropdowns-feature.selector';
export interface VehicleCategoriesState extends EntityState<VehicleCategory> {}

export const vehicleCategoriesAdapter: EntityAdapter<VehicleCategory> = createEntityAdapter<VehicleCategory>({
  selectId: (vehicleCategories: VehicleCategory) => vehicleCategories.id
});

export const initialState: VehicleCategoriesState = vehicleCategoriesAdapter.getInitialState({ loading: true });
export const vehicleCategoriesSelector = createSelector(
  svcDropdownsFeatureSelector,
  (state: any) => state.vehicleCategories
);

export const { selectIds, selectEntities, selectAll, selectTotal } = vehicleCategoriesAdapter.getSelectors(
  vehicleCategoriesSelector
);
